import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import { FilterApiService } from 'src/app/shared/services/customer-api/filter-api.service';

/**
 * get custom default filter
 */
export const filtersGuard: CanActivateFn = (next, state) => {
  const userState = inject(UserStateService);
  const router = inject(Router);
  const filterApi = inject(FilterApiService);

  if (!userState.defaultFilter && !userState.defaultFilterChecked) {
    // Set synchronously so re-activations during load don't each re-fire the fetch.
    userState.defaultFilterChecked = true;
    return filterApi.getFilter().pipe(
      map((result) => {
        result.forEach((item) => {
          if (item.name === '_default_') {
            userState.defaultFilter = item;
            // `time` is not seeded from a preset — the timeframe is an independent
            // persistent control now. Legacy presets may still carry it; ignored.
            router.navigate([state.url.split('?')[0]], {
              queryParams: {
                id: state.root.queryParams.id,
                groupId: state.root.queryParams.groupId,
                portfolioId: state.root.queryParams.portfolioId,
                type: state.root.queryParams.type,
                news: state.root.queryParams.news,
                highlight: state.root.queryParams.highlight,
                score: state.root.queryParams.score,
                filter: state.root.queryParams.filter
                  ? state.root.queryParams.filter
                  : item.filter,
                lang: state.root.queryParams.lang
                  ? state.root.queryParams.lang
                  : item.lang,
                feed: state.root.queryParams.feed
                  ? state.root.queryParams.feed
                  : item.feed
                    ? item.feed
                    : 'non_professional,online,print,professional',
                ranks: state.root.queryParams.ranks
                  ? state.root.queryParams.ranks
                  : item.ranks,
                panels: state.root.queryParams.panels
                  ? state.root.queryParams.panels
                  : item.panels,
                // categories: state.root.queryParams.categories ? state.root.queryParams.categories : (item.categories ? item.categories : 'gent,gedu,ciprof,glife,cmarkr,gpersf,gsci,gspo,gwea'),
                categories: state.root.queryParams.categories
                  ? state.root.queryParams.categories
                  : item.categories
                    ? item.categories
                    : '',
                continents: state.root.queryParams.continents
                  ? state.root.queryParams.continents
                  : item.continents,
                countries: state.root.queryParams.countries
                  ? state.root.queryParams.countries
                  : item.countries,
                factuality: state.root.queryParams.factuality
                  ? state.root.queryParams.factuality
                  : item.factuality,
                temporality: state.root.queryParams.temporality
                  ? state.root.queryParams.temporality
                  : item.temporality,
                event_ids: state.root.queryParams.event_ids
                  ? state.root.queryParams.event_ids
                  : item.event_ids,
                sort: state.root.queryParams.sort,
                eventid: state.root.queryParams.eventid,
                eventype: state.root.queryParams.eventype,
                newstype: state.root.queryParams.newstype,
              },
            });
          }
        });
        return true;
      }),
      catchError(() => {
        return of(true);
      }),
    );
  } else {
    return true;
  }
};
